module.exports = __webpack_public_path__ + "img/l_c7.076917a8.png";